export const DEFAULT_PROVIDER_NAME = "Care Connect";

const clean = (value) => (typeof value === "string" ? value.trim() : "");

// Organisation/provider name for report headers. Comes from GET app/settings
// (`providerName`, cached in localStorage "config" at login by App.js), then
// the REACT_APP_PROVIDER_NAME build-time env var, then a default.
export const getProviderName = (
  storage = window.localStorage,
  env = process.env
) => {
  try {
    const fromSettings = clean(JSON.parse(storage.getItem("config"))?.providerName);
    if (fromSettings) return fromSettings;
  } catch {
    // missing or malformed cached settings: fall through to the next source
  }
  return clean(env.REACT_APP_PROVIDER_NAME) || DEFAULT_PROVIDER_NAME;
};
